import { Injectable } from '@angular/core';
import { StringHelper } from '@osapp/helpers';
import { ConfigData } from '@osapp/model/config/ConfigData';
import Survicate from '@survicate/survicate-web-package/survicate_widget'
import { IIdlEnvironment } from 'apps/idl/src/model/IIdlEnvironment';

@Injectable({
    providedIn: 'root'
})
export class SurvicateService {
    private isInitialized: boolean = false;
    private workspaceKey: string = "";

    constructor() { }

    init(): void {
        if (this.isInitialized) return;

        //On récupère la clef dans le fichier de conf de l'environnement
        if (StringHelper.isBlank(this.workspaceKey)) {
            this.workspaceKey = (ConfigData.environment as IIdlEnvironment).survicate_workspaceId;
        }

        Survicate.init({
            workspaceKey: this.workspaceKey
        });

        this.isInitialized = true;
    }

    unload(): void {
        //TODO a conserver si besoin de forcer la suppression de la popup
        //     // Supprime la div Survicate injectée
        //     const survicateBox = document.getElementById('survicate-box');
        //     if (survicateBox) {
        //         // survicateBox.remove();
        //     }
        //     // Nettoyage de l'objet global
        //     delete (window as any).Survicate;
        // }
    }
}
